import React from "react";
import AffectedItem from "./AffectedItem";
import { useState } from "react";
// const AffectedItems = ({ records, options, label }) => {
const AffectedItems = React.forwardRef((props, ref) => {
  const [componentarr, setComponentarr] = useState([]);
  const {
    containerCls = "",
    inputProps = {},
    label,
    name,
    records,
    options,
    primaryLabel,
    error,
    baseinfo,
    formInput,
    defaultValue,
  } = props;
  return (
    <div>
      {label ? (
        <span className="pb-1 my-4 text-gray-800 incident_checkbox">
          {label}
        </span>
      ) : null}
      <hr />
      <div className="my-4">
        {records?.map((record, i) => {
          return (
            <AffectedItem
              key={i}
              record={record}
              options={options}
              defaultValue={defaultValue}
              inputProps={inputProps}
              componentarr={componentarr}
              setComponentarr={setComponentarr}
            />
          );
        })}
      </div>
    </div>
  );
});
export default AffectedItems;
